<template>
  <ElDialog name="ip-new-modal"
    :visible="show"
    v-on="$listeners"
    v-loading="loading"
    :title="$t('ip.add')"
    append-to-body
  >
    <div>
      <VForm :onSubmit="validateForm" data-vv-scope="ip-new">
        <div slot="row">
          <VGrid>
            <div slot="gridItem" type="5">
              <b>{{ $t('ip.columns.label') }}</b>
              <VInput
                type="text"
                :class="{ 'a-input--error': errors.has('ip-new.name') }"
                placeholder="e.g. Office"
                v-validate="'required'"
                data-vv-name="name"
                :data-vv-as="$t('ip.label')"
                data-vv-delay="1000"
                v-model="ip.alias"
                data-ec="allowlist_new_ip_modal"
                data-et="ip_name_input"
                data-vv-scope="ip-new"
                data-test="ip-new-name"
                data-hj-suppress
              />
              <VMessage
                type="error"
                subtype="basic"
                v-show="errors.has('ip-new.name')"
                data-test="ip-new-name-error">
                <template v-slot:icon>
                  <XMarkIcon />
                </template>
                <template v-slot:text>
                  {{ errors.first('ip-new.name') }}
                </template>
              </VMessage>
            </div>
            <div slot="gridItem" type="7">
              <b>{{ $t('ip.ipAddress') }}</b>

              <VInput
                type="text"
                :class="{ 'a-input--error': errors.has('ip-new.ip_start') }"
                placeholder="e.g. 20.0.0.1"
                v-validate="'required|ip'"
                data-vv-name="ip_start"
                :data-vv-as="$t('ip.ipAddress')"
                data-vv-delay="1000"
                data-ec="allowlist_new_ip_modal"
                data-et="ip_address_input"
                v-model="ip.ip_start"
                data-vv-scope="ip-new"
                data-hj-suppress
              />

              <VMessage
                type="error"
                subtype="basic"
                v-show="errors.has('ip-new.ip_start')"
                data-test="ip-new-ip-error">
                <template v-slot:icon>
                  <XMarkIcon />
                </template>
                <template v-slot:text>
                  {{ errors.first('ip-new.ip_start') }}
                </template>
              </VMessage>
            </div>
          </VGrid>
          <span>
            {{ $t('ip.findCurrent') }} <a target="_blank" data-ec="new_ip_modal" data-et="find_current_ip_link" href="https://www.google.co.uk/search?q=my+ip+address">Google</a>
          </span>
        </div>
        <div slot="formButtons" type="right">
          <VButton
            type="cta-1"
            subtype="submit"
            data-test="ip-new-save-button"
            data-ec="allowlist_new_ip_modal"
            data-et="add_ip_button">
            <CheckIcon />
            <span>{{ $t('ip.add') }}</span>
          </VButton>
        </div>
      </VForm>
    </div>
  </ElDialog>
</template>
<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VInput from '@/components/deprecated/atoms/Input.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import { CheckIcon, XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'AddIpModal',
  props: {
    show: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  data() {
    return {
      ip: {
        alias: '',
        ip_start: '',
        // ip_end: '',
      },
      loading: false,
    };
  },
  components: {
    VButton,
    VInput,
    VMessage,
    VForm,
    VGrid,
    CheckIcon,
    XMarkIcon,
  },
  watch: {
    show() {
      this.ip = {
        alias: '',
        ip_start: '',
      };
    },
  },
  methods: {
    validateForm(scope) {
      this.loading = true;
      this.$validator.validateAll(scope).then((validated) => {
        if (validated) {
          this.$store.dispatch('ip/CREATE', this.ip).then(() => {
            this.$store.dispatch('ip/PAGINATE', { page: 1 });
            this.$emit('close');
          }).then(() => {
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>
